import { render, staticRenderFns } from "./ConnectionWidget.vue?vue&type=template&id=60ee942f&"
import script from "./ConnectionWidget.vue?vue&type=script&lang=js&"
export * from "./ConnectionWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports